module.exports = __webpack_public_path__ + "static/img/logo14.40db294.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo14.png
// module id = 8iet
// module chunks = 1